<template>
  <v-app>
    <AppBar />
    <v-main>
      <v-container fluid style="background-color: transparent; padding: 0; overflow-x: hidden;">
        <router-view></router-view>
        <v-snackbar v-model="snck.snackbar" :color="snck.color" :timeout="snck.timeout">
          {{ snck.text }}
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import AppBar from "./components/appBar";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    AppBar,
  },
  computed: { ...mapGetters(["snackbar"]), ...mapGetters(["getLogged"]) },
  watch: {
    snackbar() {
      this.snck = this.snackbar;
    },
  },
  data: () => ({
    snck: {},
    showMenu: false,
  }),
  methods: {
  },
  created() {
    document.title = process.env.VUE_APP_TITLE;
    this.$store.dispatch('setTargetUrl', window.location.pathname);
  },
};
</script>

<style>

</style>